var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-container',[_c('b-card',[_c('h1',[_vm._v("Te has logeado con éxito")]),_c('b-button',{attrs:{"type":"submit","variant":"dark"},on:{"click":_vm.logout}},[_vm._v("Deslogear")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }